import { Ionicons } from '@expo/vector-icons'
import * as Font from 'expo-font'
import * as SplashScreen from 'expo-splash-screen'
import React, { useEffect, useState } from 'react'

import * as Sentry from 'sentry-expo'
import Config from '../constants/Config'

import ConfigService from '../services/ConfigService'
import * as Notifications from 'expo-notifications'
import DeviceTokenService from '../services/DeviceTokenService'
import { Platform } from 'react-native'
import MixpanelInstance from '../constants/Mixpanel'

const configService = new ConfigService()
const deviceTokenService = new DeviceTokenService()

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = useState(false);
  const lastNotificationResponse = Notifications.useLastNotificationResponse();

  useEffect(() => {
    if(lastNotificationResponse) {
      console.log(lastNotificationResponse)
    }
  }, [lastNotificationResponse]);

  // Load any resources or data that we need prior to rendering the app
  useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();

        Notifications.setNotificationHandler({
          handleNotification: async () => ({
            shouldShowAlert: true,
            shouldPlaySound: true,
            shouldSetBadge: true,
          }),
        });

        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
          'space-mono': require('../assets/fonts/SpaceMono-Regular.ttf'),
          'inter-light': require('../assets/fonts/Inter-Light.ttf'),
          'inter-regular': require('../assets/fonts/Inter-Regular.ttf'),
          'inter-medium': require('../assets/fonts/Inter-Medium.ttf'),
          'inter-semibold': require('../assets/fonts/Inter-Semibold.ttf'),
          'inter-bold': require('../assets/fonts/Inter-Bold.ttf'),
        });

        // Load our initial navigation state
        // setInitialNavigationState(await getInitialState());

        // sentry initialization
        Sentry.init(Config.sentry);

        // init mixpanel for native
        // if(Platform.OS === 'android') MixpanelInstance.init();

        // get/save configurations to local storage
        await configService.fetchAppConfig()

        // get/save FCM token
        deviceTokenService.fetchFcmToken()
        deviceTokenService.pushTokenToCloud()

      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();

  }, []);

  return isLoadingComplete;
}
